import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router, Event } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DatasetsService } from "../datasets/datasets.service";
import { AnonMapService } from "../../shared/models/map-services.model";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  onDestroy$ = new Subject();
  skipLinkPath: any = "";
  datasets: AnonMapService[];
  constructor(
    private router: Router,
    private datasetsService: DatasetsService
  ) {}

  ngOnInit() {
    this.getDatasets();
    this.skipLinkPath = `${this.router.url}#main`;
    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.skipLinkPath = `${this.router.url}#main`;
        }
      });
  }

  getDatasets(): void {
    this.datasetsService
      .getDatasets()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((datasets) => {
        this.datasets = datasets;
      });
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
